import React from 'react';
import { memberId } from '@trello/session-cookie';
import { AtlassianAccountOnboardingBanner } from 'app/src/components/AtlassianAccountOnboardingBanner';

export const Banners = () => {
  return (
    <>
      {/* Don't render the AaOnboardingBanner if the user isn't logged in */
      !!memberId && <AtlassianAccountOnboardingBanner />}
    </>
  );
};
